import { renderSlot as _renderSlot, withModifiers as _withModifiers, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createElementBlock("form", {
    class: _normalizeClass($options.formClasses),
    novalidate: "",
    onSubmit: _cache[0] || (_cache[0] = _withModifiers((...args) => ($options.onSubmit && $options.onSubmit(...args)), ["prevent"]))
  }, [
    _renderSlot(_ctx.$slots, "default")
  ], 34 /* CLASS, NEED_HYDRATION */))
}